<template>
    <v-container grid-list-sm text-xs-left>
    <v-layout row wrap :class="{ 'pa-2': !isMobile() }">
        <v-flex xs12>
            <IntentList></IntentList>
        </v-flex>
    </v-layout>
    </v-container>
</template>

<script>
    import {mapGetters, mapState,} from "vuex";

    import RouterService from "@/helpers/RouterService";
    import UrlsService from "@/helpers/UrlsService.js";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import List from "@/components/Lists/List";
    import IntentList from "@/components/Lists/IntentList";


    export default {
        name: "IntentsListTraining",
        components: {IntentList, List},
        created() {
            this.getIntents();
        },
        computed: {
            ...mapState({}),
            ...mapGetters("FileInputState", {
                fileInputs: "getFileInputs",
            }),
            ...mapGetters("UserState", {
                userSettings: "getSettings",
            }),
        },
        data() {
            return {
                utterances: [{text:""}],
                responses: [{text:""}],
                newIntent: {
                    id: 0,
                    //idIntent: intent.idIntent,
                    create: true,
                    intentName: "NewIntent",
                    questions: [{
                        name: "",
                        text: null,
                        type: "EXAMPLE",
                        utterance: ""
                    }],
                    answers: [""],
                },
                intentsHeader: this.$t("training.conversation.intent"),
                intents: [],
                fileInputOptions: {
                    id: "imageCap",
                    formType: "text",
                    accept: "*",
                    disabled: false,
                    capture: false,
                    multiple: true,
                    data: {
                        title: this.$t("training.files.titlePage"),
                        subtitle: this.$t("training.files.titlePage"),
                        upload: "upload",
                    },
                },
            };
        },
        methods: {
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },
            navigate(intent) {
                let path = {
                    name: "IntentTraining",
                    params: {
                        create: intent.create,
                        id: intent.idIntent,
                        intentName: intent.name,
                    },
                };
                RouterService.goTo(path);
            },
            deleteIntent(intentId, intentName){
                let requestUrl = {
                    url: UrlsService.doIntentOperation,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text: "DELETE",
                        language: this.userSettings.chatbot.language.current.locale,
                        dialogicInteractionRequest: {
                            name: intentId,
                            displayName: intentName
                        },
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "Delete Intent",
                    loading: "Waiting for deleting the intent...",
                    error: "Cannot delete the intent...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.getIntents();

                    });
            },
            getIntents() {
                let requestUrl = {
                    url: UrlsService.doIntentOperation,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text: "LIST",
                        language: this.userSettings.chatbot.language.current.locale,
                        dialogicInteractionRequest: {

                        },
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "List Intents",
                    loading: "Waiting for list of intents...",
                    error: "Cannot get intents...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.intents = [];
                        let response = responseSuccess;
                        for (let i = 0; i < response.response.intents.length; i++) {
                            let questions = [];
                            let answers = [];
                            if(response.response.intents[i].trainingPhrases !== null) {
                                for (let k = 0; k < response.response.intents[i].trainingPhrases.length; k++) {
                                    questions.push(response.response.intents[i].trainingPhrases[k]);
                                }
                            }
                            if(response.response.intents[i].messages !== null) {
                                for (let j = 0; j < response.response.intents[i].messages.length; j++) {
                                    answers.push(response.response.intents[i].messages[j]);
                                }
                            }
                            this.intents.push({
                                id: i + 1,
                                idIntent: response.response.intents[i].name,
                                name: response.response.intents[i].displayName,
                                questions: questions,
                                answers: answers,
                                create: false,
                            });
                            if (i !== response.response.intents.length - 1) {
                                this.intents.push({divider: true, inset: false,});
                            }
                        }
                    });
            },
        },
    };
</script>

<style lang="scss">

</style>

